import { AbstractAccessorService } from "@core/data-access";
import type { IDataAccessor } from "@core/data-access";
import { ISocialLoginRestService, socialRegisterParams, thirdOAuthType } from "./social-login-rest";
import { IResponse } from "@core/data-access/model";
import { socialLoginResponse } from "@modules/partner/model/domain/social-login";
import { ActionKey } from "./social-login-rest.config";
import { appConfig } from "@env/app-config";

type socialLoginParams = {
    thirdAccessToken: string,
    thirdOAuthType: thirdOAuthType
}

export class SocialLoginRestService extends AbstractAccessorService<any> implements ISocialLoginRestService {

    public readonly $name: string = "socialLoginRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<any>) {
        super();
    }

    login(thirdAccessToken: string, thirdOAuthType: thirdOAuthType): angular.IPromise<IResponse<socialLoginResponse>> {
        return this.$accessor<socialLoginResponse, socialLoginParams, ActionKey>(this.$name, "login", {
            parameter: {
                thirdAccessToken: thirdAccessToken,
                thirdOAuthType: thirdOAuthType
            }
        })
    }

    register(params: socialRegisterParams): angular.IPromise<IResponse<socialLoginResponse>> {
        return this.$accessor<socialLoginResponse, socialRegisterParams & {platform: "QPSON" | "QPMN"}, ActionKey>(this.$name, "register", {
            parameter: {
                thirdAccessToken: params.thirdAccessToken,
                thirdOAuthType: params.thirdOAuthType,
                email: params.email,
                username: params.username,
                platform: (appConfig.websiteCode.toUpperCase() as ("QPSON" | "QPMN"))
            }
        })
    }
}